import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import '@/App.css';
import { ThemeProvider } from '@/lib/theme';
import { AuthProvider } from '@/lib/auth';
import { AppShell } from '@/components/shell/AppShell';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Cards from '@/pages/Cards';
import CardDetail from '@/pages/CardDetail';
import AddCard from '@/pages/AddCard';
import Recommend from '@/pages/Recommend';
import Transactions from '@/pages/Transactions';
import Assistant from '@/pages/Assistant';
import Settings from '@/pages/Settings';
import Milestones from '@/pages/Milestones';
import Leakage from '@/pages/Leakage';
import GmailSync from '@/pages/GmailSync';
import ChromeExtensionPage from '@/pages/ChromeExtensionPage';
import Legal from '@/pages/Legal';
import { PausedGate } from '@/components/shell/PausedGate';

// Admin
import { AdminGuard } from '@/components/admin/AdminGuard';
import { AdminShell } from '@/components/admin/AdminShell';
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminBanks from '@/pages/admin/AdminBanks';
import AdminCards from '@/pages/admin/AdminCards';
import AdminCardEditor from '@/pages/admin/AdminCardEditor';
import AdminCardRules from '@/pages/admin/AdminCardRules';
import AdminAuditLog from '@/pages/admin/AdminAuditLog';
import AdminIngestCard from '@/pages/admin/AdminIngestCard';
import AdminIngestionJobs from '@/pages/admin/AdminIngestionJobs';
import AdminRuleQA from '@/pages/admin/AdminRuleQA';
import AdminRoutingHints from '@/pages/admin/AdminRoutingHints';
import AdminRoutingSuggestions from '@/pages/admin/AdminRoutingSuggestions';
import AdminCategories from '@/pages/admin/AdminCategories';
import AdminUsers from '@/pages/admin/AdminUsers';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/privacy" element={<Legal kind="privacy" />} />
              <Route path="/terms" element={<Legal kind="terms" />} />
              <Route path="/contact" element={<Legal kind="contact" />} />
              <Route element={<AppShell />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/cards" element={<Cards />} />
                <Route path="/cards/add" element={<AddCard />} />
                <Route path="/cards/:id" element={<CardDetail />} />
                <Route path="/recommend" element={<Recommend />} />
                <Route path="/transactions" element={<PausedGate title="Transactions"><Transactions /></PausedGate>} />
                <Route path="/milestones" element={<PausedGate title="Milestones"><Milestones /></PausedGate>} />
                <Route path="/leakage" element={<PausedGate title="Leakage Center"><Leakage /></PausedGate>} />
                <Route path="/assistant" element={<PausedGate title="AI Assistant"><Assistant /></PausedGate>} />
                <Route path="/sync/gmail" element={<PausedGate title="Gmail Sync"><GmailSync /></PausedGate>} />
                <Route path="/sync/extension" element={<ChromeExtensionPage />} />
                <Route path="/settings" element={<Settings />} />
              </Route>

              {/* Admin portal */}
              <Route element={<AdminGuard />}>
                <Route element={<AdminShell />}>
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/banks" element={<AdminBanks />} />
                  <Route path="/admin/cards" element={<AdminCards />} />
                  <Route path="/admin/cards/new" element={<AdminCardEditor />} />
                  <Route path="/admin/cards/:id" element={<AdminCardEditor />} />
                  <Route path="/admin/cards/:id/rules" element={<AdminCardRules />} />
                  <Route path="/admin/ingest" element={<AdminIngestCard />} />
                  <Route path="/admin/ingest/:jobId" element={<AdminIngestCard />} />
                  <Route path="/admin/ingestion-jobs" element={<AdminIngestionJobs />} />
                  <Route path="/admin/qa" element={<AdminRuleQA />} />
                  <Route path="/admin/routing-hints" element={<AdminRoutingHints />} />
                  <Route path="/admin/routing-suggestions" element={<AdminRoutingSuggestions />} />
                  <Route path="/admin/categories" element={<AdminCategories />} />
                  <Route path="/admin/users" element={<AdminUsers />} />
                  <Route path="/admin/audit-log" element={<AdminAuditLog />} />
                </Route>
              </Route>

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
